export default function generateId(length = 16): string {
  return crypto.randomUUID().replace(/-/g, '').slice(0, length);
}
